
import moment from 'moment';
import { api } from '../services/redux-beesConfig';
import AuthService from './AuthService';

import store from '../Store'
import { getActiveLanguage } from 'react-localize-redux';
class ProductsService {

  static getProducts() {
    const userID = AuthService.getUserID();
    return api.getProducts({ locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID })
      .then((res) => {
        if (res.body.token) {
          AuthService.setToken(res.body.token);
        }
        return res;
      })
      .catch((error) => {
        if (error.status === 401) {
          AuthService.logOut();
        }
      });
  }
  static freezeProduct(productId, values) {
    const userID = AuthService.getUserID();
    const endDate = moment(values.end, 'DD/MM/YYYY').format("YYYY-MM-DD") !== "Invalid date" ? moment(values.end, 'DD/MM/YYYY').format("YYYY-MM-DD") : null;
    return api.freezeProduct({ locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId }, { start: values.start, end: endDate })
      .then((res) => {
        if (res.body.token) {
          AuthService.setToken(res.body.token);
        }
        return res;
      })
  }
  static deleteFreeze(productId) {
    const userID = AuthService.getUserID();
    return api.deleteFreeze({ locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId })
    .then((res) => {
      if (res.body.token) {
        AuthService.setToken(res.body.token);
      }
      return res;
    })
  }
  static updateFreeze (productId, startDate, endDate) {
    const userID = AuthService.getUserID();
    const end = endDate === null ? null : moment(endDate, 'DD/MM/YYYY').format("YYYY-MM-DD");

    return api.updateFreeze({
      locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId,
    },{ start: startDate, end: end })
    .then((res) => {
      if (res.body.token) {
        AuthService.setToken(res.body.token);
      }
      return res;
    })
  }
  static getProduct(productId) {
    const userID = AuthService.getUserID();
    return api.getProduct({ locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId })
      .then((res) => {
        if (res.body.token) {
          AuthService.setToken(res.body.token);
        }
        return res;
      })
      .catch((error) => {
        if (error.status === 401) {
          AuthService.logOut();
        }
      });
  }
  static getFreezes(productId) {
    const userID = AuthService.getUserID();
    return api.getFreezes({ locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId })
      .then((res) => {
        if (res.body.token) {
          AuthService.setToken(res.body.token);
        }
        return res;
      })
      .catch((error) => {
        if (error.status === 401) {
          AuthService.logOut();
        }
      });
  }
  static deleteFutureFreeze(productId, freezeId) {
    const userID = AuthService.getUserID();
    return api.deleteFutureFreeze({ locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId, freezeID: freezeId })
      .then((res) => {
        if (res.body.token) {
          AuthService.setToken(res.body.token);
        }
        return res;
      })
      .catch((error) => {
        if (error.status === 401) {
          AuthService.logOut();
        }
      });
  }
  static getCallDetails(productId, { start, end, value }, page) {
    const userID = AuthService.getUserID();
    return api.getConsumption({ locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId, startDate:moment(start, 'DD-MM-YYYY').format("YYYY-MM-DD")  , endDate:moment(end, 'DD-MM-YYYY').format("YYYY-MM-DD"), type:value, 'page[number]': page, 'page[size]': 10 })
      .then((res) => {
        if (res.body.token) {
          AuthService.setToken(res.body.token);
        }
        return res;
      })
      .catch((error) => {
        if (error.status === 401) {
          AuthService.logOut();
        }
      });
  }
  static getVoiceMailInfo(productId) {
    const userID = AuthService.getUserID();
    return api.getVoiceMailInfo({ locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId })
      .then((res) => {
        if (res.body.token) {
          AuthService.setToken(res.body.token);
        }
        return res;
      })
      .catch((error) => {
        if (error.status === 401) {
          AuthService.logOut();
        }
      });
  }
  static updateVoiceMailEmail(productId, email) {
    const userID = AuthService.getUserID();
    return api.updateVoiceMail({
      locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId
    }, { action: 'voiceMailChangeEmail', email: email })
      .then((res) => {
        if (res.body.token) {
          AuthService.setToken(res.body.token);
        }
        return res;
      })
      .catch((error) => {
        if (error.status === 401) {
          AuthService.logOut();
        }
        return error;
      });
  }
  static updateVoiceMailStatus(productId) {
    const userID = AuthService.getUserID();
    return api.updateVoiceMail({
      locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId,
    },{ action: 'voiceMailChangeStatus' })
      .then((res) => {
        if (res.body.token) {
          AuthService.setToken(res.body.token);
        }
        return res;
      })
      .catch((error) => {
        if (error.status === 401) {
          AuthService.logOut();
        }
      });
  }
  static activeMispari(productId, forwardNumber, startDate, endDate) {
    const userID = AuthService.getUserID();
    const start = startDate === null ? null : moment(startDate, 'DD-MM-YYYY HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
    const end = endDate === null ? null : moment(endDate, 'DD-MM-YYYY HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
    return api.postMispari({
      locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId},{ transferTo: forwardNumber, startDate: start, endDate: end })
  }
  static updateMispari(productId, startDate, endDate, transferTo) {
    const userID = AuthService.getUserID();
    const start = startDate === null ? null : moment(startDate, 'DD-MM-YYYY HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
    const end = endDate === null ? null : moment(endDate, 'DD-MM-YYYY HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
    return api.updateMispari({ locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId},{ startDate: start, endDate: end , transferTo:transferTo});
  }
  static updateActiveMispariEndDate(productId, endDate) {
    const userID = AuthService.getUserID();
    const end = endDate === null ? null : moment(endDate, 'DD-MM-YYYY HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
    return api.updateMispari({
      locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId },{ endDate: end });
  }
  static updateActiveMispariStartDate(productId, startDate) {
    const userID = AuthService.getUserID();
    const start = startDate === null ? null : moment(startDate, 'DD-MM-YYYY HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
    return api.updateMispari({ locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId},{startDate: start });
  }

  static getMispari(productId) {
    const userID = AuthService.getUserID();
    return api.getMispari({
      locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId,
    })
      .then((res) => {
        if (res.body.token) {
          AuthService.setToken(res.body.token);
        }
        return res;
      })
      .catch((error) => {
        if (error.status === 401) {
          AuthService.logOut();
        }
        return error;
      });
  }
  static deleteMispari(productId) {
    const userID = AuthService.getUserID();
    return api.deleteMispari({
      locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId,
    });
  }

  static setLineParams(productId, filter) {
    const userID = AuthService.getUserID();

    return api.setLineParams({
      locale: `${getActiveLanguage(store.getState().locale).code}`, id: userID, productID: productId,
    },{ filter: filter })
      .then((res) => {
        if (res.body.token) {
          AuthService.setToken(res.body.token);
        }
        return res;
      })
      .catch((error) => {
        if (error.status === 401) {
          AuthService.logOut();
        }
        return error;
      });
  }
}
export default ProductsService;



// WEBPACK FOOTER //
// ./src/services/ProductsService.js